import React, { useState, useRef, useEffect } from 'react';
import data from './data.json';
import { useDispatch, useSelector } from 'react-redux';
import {
  //  POLYGON_DETAILS, POLYGON_ROI,
  SAVED_POLYGONS,
  SHOW_ZONE_INPUT
} from 'store/actions';
// import { addCameraWithZone } from 'api/sentinelAPI';
import {
  //  Button,
  IconButton,
  // TextField,
  Tooltip
} from '@mui/material';
import KeyboardReturnRoundedIcon from '@mui/icons-material/KeyboardReturnRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import defaultImage from '../../../../assets/images/Camera-013_pathway(entry-samsung)_mobile-zone.jpg';

const ImageAnnotationTool = () => {
  const [drawingData, setDrawingData] = useState([]);
  const [startPoint, setStartPoint] = useState(null);
  const [savedPolygons, setSavedPolygons] = useState([]);
  // const [polygonDetails, setPolygonDetails] = useState({});
  const polygonDetails = useSelector((state) => state.cameraReducer.polygonDetails);
  // console.log(polygonDetails);

  // const [drawCover, setDrawCover] = useState(true);
  // const checkImage = useSelector((state) => state.cameraReducer.checkImage);

  const dispatch = useDispatch();
  const imageRef = useRef(null);

  const reverseTransformArray = (inputArrays) => {
    return inputArrays.map((inputArray) => {
      return inputArray.map((point, index, array) => {
        const nextIndex = (index + 1) % array.length;
        return {
          start: { x: point.x, y: point.y },
          end: array[nextIndex] !== undefined ? { x: array[nextIndex].x, y: array[nextIndex].y } : { x: array[0].x, y: array[0].y }
        };
      });
    });
  };

  // const transformArray = (inputArray) => {
  //   return inputArray.map((subArray) => subArray.map(({ start }) => start));
  // };

  // Transform the imported data using reverseTransformArray and set it to savedPolygons
  useEffect(() => {
    const transformedData = reverseTransformArray(data);
    setSavedPolygons(transformedData);
  }, []); // Run the effect once on component mount

  const handleMouseDown = (e) => {
    const { offsetX, offsetY } = e.nativeEvent;

    if (startPoint) {
      // Draw line if startPoint exists
      setDrawingData((prevData) => [...prevData, { start: startPoint, end: { x: offsetX, y: offsetY } }]);
      setStartPoint({ x: offsetX, y: offsetY });
    } else {
      // Set startPoint if it doesn't exist
      setStartPoint({ x: offsetX, y: offsetY });
    }
  };

  const handleUndo = () => {
    if (drawingData.length > 0) {
      // Remove the last drawn line segment
      setDrawingData((prevData) => prevData.slice(0, -1));

      // If there are points left, update the startPoint to the last drawn point
      if (drawingData.length > 1) {
        setStartPoint({
          x: drawingData[drawingData.length - 2].end.x,
          y: drawingData[drawingData.length - 2].end.y
        });
      } else {
        // If no points left, reset startPoint to null
        setStartPoint(null);
      }
    }
  };

  const calculateHighlightPoints = () => {
    const points = drawingData.map((line) => [line.start.x, line.start.y]);

    if (points.length >= 3) {
      // Add the last line's end point to close the shape for highlighting
      points.push([drawingData[drawingData.length - 1].end.x, drawingData[drawingData.length - 1].end.y]);
    }

    return points;
  };

  const handleDone = () => {
    if (drawingData.length > 0) {
      // Include the last dot when clicking "Done"
      const completedPolygon = [
        ...drawingData,
        {
          start: drawingData[drawingData.length - 1].end,
          end: drawingData[0].start
        }
      ];
      setDrawingData(completedPolygon);
      setSavedPolygons((prevPolygons) => [
        ...prevPolygons,
        { roi: [completedPolygon.map((obj) => [obj.start, obj.end]).flat()], details: polygonDetails }
      ]);
      setDrawingData([]);
      setStartPoint(null);
      dispatch({ type: SHOW_ZONE_INPUT, showZoneInput: true });
    }
  };
  useEffect(() => {
    if (polygonDetails) {
      setSavedPolygons((prevPolygons) =>
        prevPolygons.map((polygon, index) => (index === prevPolygons.length - 1 ? { ...polygon, details: polygonDetails } : polygon))
      );
    }
  }, [polygonDetails]);
  useEffect(() => {
    dispatch({ type: SAVED_POLYGONS, savedPolygons: savedPolygons });
    // eslint-disable-next-line
  }, [savedPolygons]);

  return (
    <div
      style={{
        position: 'relative',
        width: '100%'
      }}
    >
      <div>
        <div className="relative">
          <img
            ref={imageRef}
            src={defaultImage}
            // src={
            //   `data:image/jpeg;base64,${checkImage[0]?.frame}` ||
            //   'https://images.unsplash.com/photo-1441986300917-64674bd600d8?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
            // }
            alt="Annotated Image"
            className="w-[90%] h-[calc(100vh-60px)] p-4 cursor-crosshair rounded-2xl "
            onMouseDown={handleMouseDown}
          />
          {/* {drawCover && (
            <div
              onClick={() => setDrawCover(false)}
              className="rounded-lg font-bold text-4xl text-gray-500 absolute left-0 top-0 z-10 bg-gray-300/80 w-full h-full justify-center items-center flex"
            >
              Draw Zone
            </div>
          )} */}
        </div>
        {drawingData.map((line, index) => (
          <div
            key={index}
            style={{
              position: 'absolute',
              top: line.start.y,
              left: line.start.x,
              width: Math.sqrt(Math.pow(line.end.x - line.start.x, 2) + Math.pow(line.end.y - line.start.y, 2)),
              height: 2,
              backgroundColor: 'red',
              transform: `rotate(${Math.atan2(line.end.y - line.start.y, line.end.x - line.start.x)}rad)`,
              transformOrigin: '0 0',
              pointerEvents: 'none'
            }}
          />
        ))}
        {startPoint && (
          <div
            style={{
              position: 'absolute',
              top: startPoint.y - 2,
              left: startPoint.x - 2,
              width: 4,
              height: 4,
              backgroundColor: 'red',
              borderRadius: '50%',
              pointerEvents: 'none'
            }}
          />
        )}

        <svg
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            pointerEvents: 'none'
          }}
          width="100%"
          height="100%"
        >
          {/* Saved Polygons */}
          {savedPolygons.map((polygonObj, polyIndex) => {
            if (polyIndex > 1) {
              const { details } = polygonObj;
              let roi = polygonObj.roi[0];
              roi = roi.reduce((acc, value, index, arr) => {
                if (index % 2 === 0) {
                  acc.push({ start: value, end: arr[index + 1] });
                }
                return acc;
              }, []);
              if (!roi || roi.length === 0) return null;

              // Calculate the centroid of the polygon for placing the text
              const centroid = roi.reduce(
                (acc, point) => ({
                  x: acc.x + point.start.x,
                  y: acc.y + point.start.y
                }),
                { x: 0, y: 0 }
              );
              centroid.x /= roi.length;
              centroid.y /= roi.length;

              return (
                <g key={polyIndex}>
                  <polygon
                    fill={details ? `${details?.colourHex}50` : 'rgba(0, 255, 0, 0.3)'}
                    points={roi.map((point) => `${point.start.x},${point.start.y}`).join(' ')}
                  />
                  <text x={centroid.x} y={centroid.y} fill="black" fontSize="14" textAnchor="middle" dominantBaseline="middle">
                    {details?.zone_name || 'Zone'}
                  </text>
                </g>
              );
            } else return;
          })}

          {/* Highlight Polygon */}
          <polygon fill="rgba(0, 255, 0, 0.3)" points={calculateHighlightPoints().flat().join(' ')} />
        </svg>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.3rem'
        }}
      >
        {/* <Tooltip title="Undo"> */}
        <IconButton
          onClick={handleUndo}
          style={{
            cursor: 'pointer',
            position: 'absolute',
            backgroundColor: 'white',
            top: '20px',
            right: '250px',
            color: 'black',
            zIndex: 2,
            borderRadius: '0.5rem',
            outline: 'none'
          }}
        >
          <KeyboardReturnRoundedIcon />
        </IconButton>
        {/* </Tooltip> */}
        <Tooltip title="Done">
          <IconButton
            onClick={handleDone}
            style={{
              cursor: 'pointer',
              position: 'absolute',
              backgroundColor: 'white',
              top: '20px',
              right: '180px',
              color: 'black',
              zIndex: 2,
              borderRadius: '0.5rem',
              outline: 'none'
            }}
          >
            <CheckRoundedIcon />
          </IconButton>
        </Tooltip>
      </div>
    </div>
  );
};

export default ImageAnnotationTool;
